<template>
  <div class="text-center lead" style="padding-top: 15%">
    Oops<br />
    Something went wrong.<br />
    <p>Please contact BOLT administrators for any questions.</p>
    <button class="btn btn-primary btn-sm mb-3" @click.prevent="$router.go(-2)">
      Back to previous page
    </button>
  </div>
</template>

<script>
export default {
  name: "ErrorGeneralView",
};
</script>
